import React, { useState, useEffect } from "react";
import { Col, DatePicker, ConfigProvider } from "antd";
import { GoCalendar } from "react-icons/go";
import moment from "moment";
import locale from "antd/es/locale/en_GB";
import { AiFillCaretLeft, AiFillCaretRight } from "react-icons/ai";
import "./customcalendar.css";

const CustomCalendar = (props) => {
  const dayStart = moment().startOf("week").toDate();
  dayStart.setDate(dayStart.getDate() + 1);
  dayStart.setUTCHours(0, 0, 0, 0);
  const daystart2 = dayStart.toISOString();
  const weekEnd = moment().endOf("week").toDate();
  weekEnd.setUTCHours(0, 0, 0, 0);
  const weekEnd2 = weekEnd.toISOString();

  const [boolDate, setBoolDate] = useState(false);
  const [startDate, setStartDate] = useState(daystart2);
  const [endDate, setEndDate] = useState(weekEnd2);
  const [dateSelected, setDateSelected] = useState(weekEnd);
  const [getWeek, setWeek] = useState();

  useEffect(() => {
    props.setStartdate(startDate);
    props.setEnddate(endDate);
  }, [props]);

  const getdates = (date, dateString) => {
    setBoolDate(true);
    const firstday = dateString.split("-")[0];
    var firsday2 = new Date(firstday);
    firsday2 = new Date(
      firsday2.getFullYear(),
      firsday2.getMonth(),
      firsday2.getDate() + 1
    ).toISOString();
    setStartDate(firsday2);
    var lastDay = dateString.split("-")[1];
    var lastDay2 = new Date(lastDay);
    lastDay2 = new Date(
      lastDay2.getFullYear(),
      lastDay2.getMonth(),
      lastDay2.getDate() + 1
    ).toISOString();
    setEndDate(lastDay2);
    setDateSelected(lastDay);

    props.setStartdate(firsday2);
    props.setEnddate(lastDay2);
  };

  const shiftCalenderRight = () => {
    var abc = moment();
    var abc2 = new Date(abc._d);
    abc2 = new Date(abc2.getFullYear(), abc2.getMonth(), abc2.getDate() + 6);
    var day = new Date(dateSelected ? dateSelected : abc2);
    const nextWeek = new Date(
      day.getFullYear(),
      day.getMonth(),
      day.getDate() + 7
    );
    const nextWeekShift = new Date(
      day.getFullYear(),
      day.getMonth(),
      day.getDate() + 2
    ).toISOString();
    const endofweek = new Date(
      day.getFullYear(),
      day.getMonth(),
      day.getDate() + 8
    ).toISOString();
    setDateSelected(nextWeek);
    setStartDate(nextWeekShift);
    setEndDate(endofweek);
    setWeek(nextWeek);

    props.setStartdate(nextWeekShift);
    props.setEnddate(endofweek);
  };

  const shiftCalenderLeft = () => {
    setBoolDate(false);
    var abc = moment();
    var day = new Date(dateSelected ? dateSelected : abc);
    const endDateofPreviousWeek = new Date(
      day.getFullYear(),
      day.getMonth(),
      day.getDate() - 6
    );

    endDateofPreviousWeek.setUTCHours(0, 0, 0, 0);
    const startDateofPreviousWeek = new Date(
      endDateofPreviousWeek.getFullYear(),
      endDateofPreviousWeek.getMonth(),
      endDateofPreviousWeek.getDate() - 5
    );
    startDateofPreviousWeek.setUTCHours(0, 0, 0, 0);

    setEndDate(endDateofPreviousWeek.toISOString());
    setStartDate(startDateofPreviousWeek.toISOString());
    setDateSelected(endDateofPreviousWeek);
    setWeek(endDateofPreviousWeek);

    props.setStartdate(startDateofPreviousWeek.toISOString());
    props.setEnddate(endDateofPreviousWeek.toISOString());
  };

  const weekFormat = "MMMM DD, YYYY";
  const customWeekStartEndFormat = (value) =>
    `${moment(value).startOf("week").format(weekFormat)} - ${moment(value)
      .endOf("week")
      .format(weekFormat)}`;

  return (
    <Col style={{ margin: "auto" }}>
      <AiFillCaretRight
        className="custom-calender-arrow-right"
        onClick={shiftCalenderRight}
      />
      <AiFillCaretLeft
        className="custom-calender-arrow-left"
        onClick={shiftCalenderLeft}
      />
      <div className="datepicker-div custom">
        <ConfigProvider locale={locale}>
          <DatePicker
            defaultValue={moment()}
            onChange={getdates}
            value={boolDate ? moment(dateSelected) : moment(getWeek)}
            suffixIcon={
              <GoCalendar
                className="calendar-icon"
                disabledDate={(current) => {
                  return moment().add(-1, "days") >= current;
                }}
              />
            }
            format={customWeekStartEndFormat}
            picker="week"
          />
        </ConfigProvider>
      </div>
    </Col>
  );
};
export default CustomCalendar;
